import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

interface Promo {
  id: number;
  title: string;
  description: string;
  discount: string;
  validUntil: string;
  terms: string[];
  icon: string;
  color: string;
  featured: boolean;
}

export default function Promo() {
  const promos: Promo[] = [
    {
      id: 1,
      title: 'Paket Hemat Servis Laptop',
      description: 'Install ulang Windows + Office + pembersihan menyeluruh',
      discount: 'Hemat 30%',
      validUntil: '31 Maret 2024',
      terms: [
        'Hanya Rp 100.000 (harga normal Rp 145.000)',
        'Gratis antivirus premium',
        'Garansi 1 bulan',
        'Berlaku untuk semua merk laptop'
      ],
      icon: 'ri-computer-line',
      color: 'from-blue-500 to-blue-600',
      featured: true
    },
    {
      id: 2,
      title: 'Promo Cetak Foto Kilat',
      description: 'Cetak 100 foto ukuran 4R hanya dalam 1 jam',
      discount: 'Diskon 25%',
      validUntil: '30 April 2024',
      terms: [
        'Hanya Rp 150.000 untuk 100 foto 4R',
        'Kualitas premium glossy/doff',
        'Gratis soft file hasil edit',
        'Minimal order 50 foto'
      ],
      icon: 'ri-camera-line',
      color: 'from-purple-500 to-purple-600',
      featured: true
    },
    {
      id: 3,
      title: 'Paket CCTV Rumah',
      description: 'Pasang 4 kamera CCTV 2MP dengan DVR dan instalasi lengkap',
      discount: 'Gratis Instalasi',
      validUntil: '15 April 2024',
      terms: [
        'Paket lengkap mulai Rp 2.500.000',
        'Gratis setting remote via HP',
        'Garansi 1 tahun',
        'Free maintenance 3 bulan pertama'
      ],
      icon: 'ri-webcam-line',
      color: 'from-red-500 to-red-600',
      featured: false
    },
    {
      id: 4,
      title: 'Desain Logo + Kartu Nama',
      description: 'Paket branding lengkap untuk UMKM',
      discount: 'Bundling 40%',
      validUntil: '31 Maret 2024',
      terms: [
        'Hanya Rp 150.000 (hemat Rp 100.000)',
        '3 konsep desain logo',
        'Cetak 100 kartu nama premium',
        'File source HD untuk semua keperluan'
      ],
      icon: 'ri-palette-line',
      color: 'from-pink-500 to-rose-600',
      featured: false
    },
    {
      id: 5,
      title: 'Undangan Digital Premium',
      description: 'Website undangan pernikahan dengan fitur lengkap',
      discount: 'Harga Spesial',
      validUntil: '30 April 2024',
      terms: [
        'Mulai Rp 150.000 (harga normal Rp 250.000)',
        'Desain custom sesuai tema',
        'Fitur RSVP, galeri, musik',
        'Gratis revisi unlimited'
      ],
      icon: 'ri-smartphone-line',
      color: 'from-green-500 to-green-600',
      featured: false
    },
    {
      id: 6,
      title: 'Upgrade SSD + RAM',
      description: 'Tingkatkan performa laptop hingga 5x lebih cepat',
      discount: 'Gratis Pasang',
      validUntil: '15 April 2024',
      terms: [
        'Gratis jasa instalasi (senilai Rp 100.000)',
        'Gratis cloning data dari HDD lama',
        'Garansi SSD 3 tahun',
        'Konsultasi upgrade gratis'
      ],
      icon: 'ri-hard-drive-line',
      color: 'from-orange-500 to-orange-600',
      featured: false
    }
  ];

  const featuredPromos = promos.filter(p => p.featured);
  const regularPromos = promos.filter(p => !p.featured);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-block mb-4">
              <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
                Promo Spesial
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
              Penawaran Terbaik Bulan Ini
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Dapatkan diskon dan paket hemat untuk berbagai layanan kami
            </p>
          </div>

          {/* Featured Promos */}
          <div className="mb-16">
            <h2 className="text-2xl font-bold text-[#0B1F3B] mb-6 flex items-center gap-3">
              <i className="ri-fire-fill text-[#FF8A00]"></i>
              Promo Unggulan
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
              {featuredPromos.map((promo) => (
                <div
                  key={promo.id}
                  className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#FF8A00]"
                >
                  <div className={`bg-gradient-to-br ${promo.color} p-8 text-white relative overflow-hidden`}>
                    <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -mr-20 -mt-20"></div>
                    <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/10 rounded-full -ml-16 -mb-16"></div>
                    <div className="relative z-10">
                      <div className="flex items-start justify-between mb-4">
                        <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl">
                          <i className={`${promo.icon} text-4xl`}></i>
                        </div>
                        <div className="bg-white text-[#0B1F3B] px-4 py-2 rounded-full font-bold text-lg">
                          {promo.discount}
                        </div>
                      </div>
                      <h3 className="text-2xl font-bold mb-2">{promo.title}</h3>
                      <p className="text-white/90">{promo.description}</p>
                    </div>
                  </div>

                  <div className="p-8">
                    <div className="mb-6">
                      <div className="flex items-center gap-2 text-gray-500 mb-3">
                        <i className="ri-calendar-line"></i>
                        <span className="text-sm">Berlaku hingga: <strong className="text-[#FF8A00]">{promo.validUntil}</strong></span>
                      </div>
                      <h4 className="font-bold text-[#0B1F3B] mb-3">Syarat & Ketentuan:</h4>
                      <ul className="space-y-2">
                        {promo.terms.map((term, index) => (
                          <li key={index} className="flex items-start gap-2 text-gray-700 text-sm">
                            <i className="ri-checkbox-circle-fill text-[#FF8A00] mt-0.5 flex-shrink-0"></i>
                            <span>{term}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <a
                      href="https://wa.me/6285868360910"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full bg-[#25D366] hover:bg-[#20bd5a] text-white py-4 rounded-xl font-semibold text-lg transition-all flex items-center justify-center gap-3 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-whatsapp-fill text-2xl"></i>
                      Ambil Promo Ini
                      <i className="ri-arrow-right-line text-xl"></i>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Regular Promos */}
          <div>
            <h2 className="text-2xl font-bold text-[#0B1F3B] mb-6 flex items-center gap-3">
              <i className="ri-price-tag-3-fill text-[#FF8A00]"></i>
              Promo Lainnya
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
              {regularPromos.map((promo) => (
                <div
                  key={promo.id}
                  className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-200"
                >
                  <div className={`bg-gradient-to-br ${promo.color} p-6 text-white relative overflow-hidden`}>
                    <div className="absolute top-0 right-0 w-24 h-24 bg-white/10 rounded-full -mr-12 -mt-12"></div>
                    <div className="relative z-10">
                      <div className="flex items-start justify-between mb-3">
                        <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl">
                          <i className={`${promo.icon} text-2xl`}></i>
                        </div>
                        <div className="bg-white text-[#0B1F3B] px-3 py-1 rounded-full font-bold text-sm">
                          {promo.discount}
                        </div>
                      </div>
                      <h3 className="text-xl font-bold mb-1">{promo.title}</h3>
                      <p className="text-sm text-white/90">{promo.description}</p>
                    </div>
                  </div>

                  <div className="p-6">
                    <div className="flex items-center gap-2 text-gray-500 mb-4 text-sm">
                      <i className="ri-calendar-line"></i>
                      <span>s/d {promo.validUntil}</span>
                    </div>
                    <ul className="space-y-2 mb-6">
                      {promo.terms.slice(0, 3).map((term, index) => (
                        <li key={index} className="flex items-start gap-2 text-gray-700 text-sm">
                          <i className="ri-checkbox-circle-fill text-[#FF8A00] mt-0.5 flex-shrink-0"></i>
                          <span className="line-clamp-2">{term}</span>
                        </li>
                      ))}
                    </ul>

                    <a
                      href="https://wa.me/6285868360910"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] hover:from-[#0d2847] hover:to-[#0B1F3B] text-white py-3 rounded-xl font-semibold transition-all flex items-center justify-center gap-2 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-whatsapp-fill text-lg"></i>
                      Pesan Sekarang
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Banner */}
          <div className="mt-16 bg-gradient-to-r from-[#FF8A00] to-[#ff9d33] rounded-3xl p-8 md:p-12 text-white text-center">
            <div className="max-w-3xl mx-auto">
              <div className="w-20 h-20 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-2xl mx-auto mb-6">
                <i className="ri-gift-line text-4xl"></i>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Ingin Promo Khusus untuk Anda?
              </h2>
              <p className="text-lg text-white/90 mb-8">
                Hubungi kami sekarang dan dapatkan penawaran terbaik sesuai kebutuhan Anda
              </p>
              <a
                href="https://wa.me/6285868360910"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-white text-[#FF8A00] hover:bg-gray-100 px-8 py-4 rounded-xl font-semibold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-2xl"></i>
                Chat Sekarang
                <i className="ri-arrow-right-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}